
import React from 'react';
import { Helmet } from 'react-helmet';

const HeadManager = ({ pageData, language }) => {

	const translations = pageData && pageData.translations ? pageData.translations[language] : null;
	const pageTitle = translations ? translations.pageTitle : "";
	const onetrustId = process.env.REACT_APP_ONETRUST_ID || '#{ONETRUST_ID}';

	return (
		<Helmet>
			{/* #{ONETRUST_ID} would be replaced on deploy and that would change the logic => check for contains */}
			{/* eslint-disable-next-line */}                        
	        {onetrustId && !onetrustId.includes('ONETRUST_ID') && (
			<script id="OneTrustScript" src="//cdn.cookielaw.org/scripttemplates/otSDKStub.js" data-document-language="true" type="text/javascript" charset="UTF-8" data-domain-script={onetrustId}></script>
			)}
			<html lang={language} />
			<title>{pageTitle}</title>
			<meta name="title" content={pageTitle} />
			<meta name="description" content={translations?.metaDescription} />
			<meta name="keywords" content={translations?.metaKeywords} />
			{/* CSP via HeadManager is not working properly and will not block everything. This should be set by the server  

			<meta http-equiv="Content-Security-Policy" 
				content={`default-src 'self';
    				img-src data: https: http:;
    				script-src 'self' 'unsafe-inline' 'unsafe-eval' https://cdn.cookielaw.org/;
					connect-src 'self' https://cdn.cookielaw.org/ https://geolocation.onetrust.com/ ${dataUrl};
    				style-src 'self' 'unsafe-inline'; `}/> */}
		</Helmet>
	);
}

export default HeadManager;